/**
 * get the country flag
 */

import React, { ReactNode, createElement, useEffect, useState } from 'react'

type FlagProps = { country: string }

const flags: { country: string; svg: string }[] = []

function useSVGLoader(country: string) {
  const [svg, setSvg] = useState<string>('')

  useEffect(() => {
    const _waitForData = async () => {
      const flag = flags.find(item => {
        return item.country === country
      })
      if (flag) {
        setSvg(flag.svg)
      } else {
        const file = `/images/flags/${country}.svg`
        fetch(file)
          .then((rawData) => { return rawData.text() })
          .then((svg) => {
            setSvg(svg)
            flags.push({ country, svg })
          })
      }
    }
    _waitForData()
  }, [country])

  return [svg]
}

const Flag = ({ country }: FlagProps) => {
  const [svg] = useSVGLoader(country)
  return (<i className='country-flag' dangerouslySetInnerHTML={{ __html: svg }}></i>)
}
export default Flag
